module.exports = __webpack_public_path__ + "static/media/icon-quality-orange.747140a7.svg";